/*
  Task: Add option to close the loyalty program button
  The Leat loyalty launcher (.leat-floating-panel-launcher-container) is a
  third-party embed with no built-in dismiss control, so it sits on screen
  permanently next to the AI chat bubble/contact button. This attaches a
  small close ("x") button on top of the launcher; dismissing it hides the
  launcher and remembers the choice (localStorage) so it stays hidden on
  later visits, site-wide, until storage is cleared.

  The launcher is assumed to already be a positioned element (position:fixed
  is required by Leat for it to float in place, which is also why our
  z-index override elsewhere on this element takes effect) - so the close
  button can be absolutely positioned against it without us having to touch
  its own position property.
*/
(function () {
  var STORAGE_KEY = 'loyaltyWidgetDismissed';
  var LAUNCHER_SELECTOR = '.leat-floating-panel-launcher-container';
  var CLOSE_BTN_CLASS = 'loyalty-widget-close-btn';

  function isDismissed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function dismiss(launcher) {
    launcher.style.setProperty('display', 'none', 'important');
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function addCloseButton(launcher) {
    if (!launcher || launcher.querySelector('.' + CLOSE_BTN_CLASS)) return;

    if (isDismissed()) {
      launcher.style.setProperty('display', 'none', 'important');
      return;
    }

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = CLOSE_BTN_CLASS;
    closeBtn.setAttribute('aria-label', 'Close loyalty program button');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dismiss(launcher);
    });

    launcher.appendChild(closeBtn);
  }

  function scan(root) {
    (root || document).querySelectorAll(LAUNCHER_SELECTOR).forEach(addCloseButton);
  }

  scan();

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches(LAUNCHER_SELECTOR)) addCloseButton(node);
        scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
